import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@Constants/queryKeys";
import NotificationService from "../../../services/NotificationService";
import { ResponseType } from "@Utils/types";
import { UsersApiService } from "@Api/users-service";

export const useUserProfile = () => {
  return useQuery({
    queryKey: [queryKeys.userManagement.profile],
    queryFn: async () => {
      const { ok, response, data } = await UsersApiService.getProfileDetails();
      if (ok) {
        return data?.data;
      }
      throw response?.message;
    },
  });
};

export const useUserTotalStats = () => {
  return useQuery({
    queryKey: [queryKeys.userManagement.stats],
    queryFn: async () => {
      const { ok, response, data } = await UsersApiService.getUsersStats();
      if (ok) {
        return data;
      }
      throw response?.message;
    },
  });
};

export const useUserDetails = (userId: string) => {
  return useQuery({
    queryKey: [queryKeys.userManagement.details, userId],
    queryFn: async () => {
      const { ok, response, data } = await UsersApiService.getUserDetails({
        userId
      });
      if (ok) {
        return data?.data;
      }
      throw response?.message;
    },
  });
};



export const updateUserStatus = () => {
  const queryClient = useQueryClient();
  return useMutation<ResponseType, Error, any>({
    mutationFn: (payload: { userId: string; activateUser: boolean }) =>
      UsersApiService.updateUserStatus(payload),
    onSuccess: ({ ok, response, data }: ResponseType) => {
      if (ok) {
        NotificationService.success("User status updated successfully.");
        queryClient.invalidateQueries({
          queryKey: [queryKeys.userManagement.details],
        });
        return;
      }
      NotificationService.error(data?.data?.metadata?.message);
      throw response.message;
    },
    onError: (err: any) => {
      throw err;
    },
  });
};
